"use strict";

import Masonry from 'masonry-layout/masonry';
import imagesLoaded from 'imagesloaded/imagesloaded';

window.socialMediaContainer = document.querySelector('.social-media-items');
let item = document.querySelector('.social-media-items .item');
let masonry = null;

if (window.socialMediaContainer) {
    window.msnry = createMasonry(window.socialMediaContainer, item);

    imagesLoaded(window.socialMediaContainer, () => {
        window.msnry.layout();
    });
}

function createMasonry(grid, item) {
    return new Masonry(grid, {
        itemSelector: '.item',
        columnWidth: item,
        gutter: 50,
        percentPosition: true
    });
}

function resize(masonry, grid, item) {
    if (masonry) {
        masonry.destroy();
    }
    if (grid) {
        grid = document.querySelector('.social-media-items');
    }
    if (item) {
        item = document.querySelector('.social-media-items .item');
    }
    window.msnry = createMasonry(grid, item);
    window.msnry.layout();
}

if (masonry && grid && item) {
    window.addEventListener('resize', () => {
        resize(window.msnry, window.socialMediaContainer, item);
    });

    window.addEventListener('orientationchange', () => {
        resize(window.msnry, window.socialMediaContainer, item);
    });
}
